module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loginpage"
  }, [_c('div', {
    staticClass: "login-box",
    class: {
      changewidth: _vm.isActive
    }
  }, [_c('img', {
    staticStyle: {
      "margin-top": "50px"
    },
    attrs: {
      "src": require("../assets/antgine_LOGO.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "login-title",
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v("蚁巢云平台")]), _vm._v(" "), _c('div', {
    staticClass: "login-box-body"
  }, [_c('el-form', {
    ref: "loginForm",
    attrs: {
      "model": _vm.loginForm,
      "rules": _vm.rules2
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "300px",
      "background-color": "#f7f7f7",
      "border-radius": "5px"
    },
    attrs: {
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "size": "large",
      "auto-complete": "off",
      "placeholder": "请输入您的账号"
    },
    model: {
      value: (_vm.loginForm.name),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "name", $$v)
      },
      expression: "loginForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "margin": "0 auto",
      "width": "300px",
      "background-color": "#f7f7f7",
      "border-radius": "5px"
    },
    attrs: {
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "size": "large",
      "auto-complete": "off",
      "placeholder": "请输入您的密码"
    },
    model: {
      value: (_vm.loginForm.password),
      callback: function($$v) {
        _vm.$set(_vm.loginForm, "password", $$v)
      },
      expression: "loginForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    staticStyle: {
      "border-radius": "5px",
      "background-color": "#fb3846",
      "color": "#fff",
      "width": "300px",
      "margin-top": "30px"
    },
    attrs: {
      "plain": true,
      "loading": _vm.loginload
    },
    on: {
      "click": function($event) {
        _vm.submitForm('loginForm')
      }
    }
  }, [_vm._v("确定")])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3aa2a962!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 1051
// module chunks = 2